// stockMobileApi.js — appels réseau des écrans Stock mobile.
// Mêmes endpoints et mêmes paramètres que le desktop (src/gestion-stock/GestionStock.jsx
// et StockProductHistory.jsx), regroupés ici pour ne pas dupliquer axios dans chaque écran.
import axios from "axios";

// Le backend renvoie tantôt `total`, tantôt un objet `pagination` (GestionStock.jsx:196).
export const getPaginationTotal = (data) =>
  data?.total ?? data?.pagination?.totalItems ?? data?.pagination?.total ?? 0;

/* ---------- transferts ---------- */
export async function fetchTransfers({ warehouse, viewType, page, limit }) {
  const res = await axios.get("/api/orders", {
    params: {
      order_type: "stock-transfer",
      warehouse,
      view_type: viewType,
      page,
      limit,
    },
  });
  return { rows: res.data.orders || [], total: getPaginationTotal(res.data) };
}

export async function fetchTransferItems(transferId) {
  // Le endpoint répond par un tableau nu (cf. GestionStock.jsx:459).
  const res = await axios.get(`/api/orders/${transferId}/items`);
  const d = res.data;
  if (Array.isArray(d)) return d;
  return Array.isArray(d?.items) ? d.items : [];
}

export const deleteTransfer = (transferId) =>
  axios.delete(`/api/orders/${transferId}`);

/* ---------- ajustements ---------- */
export async function fetchAdjustments({ warehouseId, page, limit, productId }) {
  const params = {
    warehouse_id: warehouseId,
    page,
    limit,
    sort_by: "created_at",
    order: "desc",
  };
  if (productId) params.product_id = productId;

  const res = await axios.get("/api/stock-adjustments", { params });
  return { rows: res.data.adjustments || [], total: getPaginationTotal(res.data) };
}

export function saveAdjustment(id, payload) {
  return id
    ? axios.put(`/api/stock-adjustments/${id}`, payload)
    : axios.post("/api/stock-adjustments", payload);
}

export const saveAdjustmentBatch = (payload) =>
  axios.post("/api/stock-adjustments/batch", payload);

export function deleteAdjustment(id, companyId, valuationEventId) {
  const config = {
    ...(companyId ? { headers: { "X-Company-Id": String(companyId) } } : {}),
    ...(valuationEventId !== undefined ? { data: { expected_valuation_event_id: valuationEventId } } : {}),
  };
  return axios.delete(`/api/stock-adjustments/${id}`, config);
}

/* ---------- produits / magasins ---------- */
export async function fetchProducts(warehouseId) {
  const res = await axios.get("/api/stock-adjustments/products", {
    params: { warehouse_id: warehouseId, limit: 5000 },
  });
  return Array.isArray(res.data?.products) ? res.data.products : [];
}

export async function fetchWarehouses(companyId) {
  const res = await axios.get("/api/warehouses", {
    params: { company_id: companyId },
  });
  return res.data.warehouses || [];
}

/* ---------- historique produit (cycle de vie) ---------- */
export async function fetchLifecycle({
  companyId,
  page,
  limit,
  search,
  warehouseId,
  eventTypes,
  startDate,
  endDate,
}) {
  const params = { company_id: companyId, page, limit };
  if (search?.trim()) params.search = search.trim();
  if (warehouseId) params.warehouse_id = warehouseId;
  if (eventTypes?.length) params.event_types = eventTypes.join(",");
  if (startDate) params.start_date = startDate;
  if (endDate) params.end_date = endDate;

  const res = await axios.get("/api/product-lifecycle", { params });
  return { rows: res.data.items || [], total: getPaginationTotal(res.data) };
}
